import React from "react";

function Typology({ room_type, t }) {
  return (
    <div>
      <div>{t("type")}</div>
      <div>
        <strong>{t(room_type)}</strong>
      </div>
    </div>
  );
}

export default Typology;
